var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(false)?_c('div',{style:(`height:${_vm.height}px; border: none;`)},[_c('iframe',{attrs:{"src":_vm.policyPathUrl,"title":_vm.policyTitle,"width":"100%","height":"100%"}})]):_vm._e(),_c('div',{staticStyle:{"overflow-y":"scroll","height":"200px"}},[_c('policy-privacy',{attrs:{"resource":_vm.resource}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }